import {Layer} from "features/apartmentViewer/ApartmentViewer/layers/Layer";

export class LayerContainer {
    layers: Layer[];
    public needsUpdate: boolean;

    constructor() {
        this.needsUpdate = true;
        this.layers = [];
    }

    addLayer (layer: Layer) {
        this.layers.push(layer);
        this.needsUpdate = true;
    }

    getActiveLayersCount() {
        let activeLayers = 0;

        for (let index = 0; index < this.layers.length; index++) {
            if (this.layers[index].isActive) activeLayers++;
        }

        return activeLayers
    }
}
